/**
 * California-only reporting surfaces.
 *
 * Two printout features exist because California regulates them specifically — the CDPH 530 staffing
 * form and the CDPH §72329.2 census readings (midnight / 8 AM / 4 PM). Both ask the same question of a
 * department, so both read it from here rather than each re-deriving it.
 *
 * Timezone is the proxy for state: departments carry no state column, and every Californian building
 * runs on Pacific time. Demo departments are included so the features can be shown in a demo of any
 * timezone.
 */
export const CALIFORNIA_TIMEZONE = "America/Los_Angeles";

export const isCaliforniaDepartment = (timezone: string, isAnyDemo: boolean): boolean => timezone === CALIFORNIA_TIMEZONE || isAnyDemo;
